"use strict";

exports.__esModule = true;
var _DeviceRoutes = require("./DeviceRoutes");
Object.keys(_DeviceRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceRoutes[key]) return;
  exports[key] = _DeviceRoutes[key];
});